module.exports = __webpack_public_path__ + "img/AR15.dce82145.png";